import React from "react";
import { Share2 } from "lucide-react";
import { SHARE_NETWORK_META } from "@/pages/admin/dashboard/constants";

/** Lists each social network with a colored bullet + share count. */
const ShareNetworksList = ({ items, lang }) => {
  if (!items || items.length === 0) {
    return (
      <div className="py-8 text-center">
        <Share2 className="w-6 h-6 text-[#C5A059] mx-auto mb-2 opacity-50" strokeWidth={1.25} />
        <p className="text-xs text-[#A19E9C]">
          {lang === "fr"
            ? "Aucun partage enregistré pour l'instant"
            : "No share clicks recorded yet"}
        </p>
      </div>
    );
  }
  return (
    <ul className="space-y-2.5 max-h-[220px] overflow-y-auto pr-1">
      {items.map((s) => {
        const meta = SHARE_NETWORK_META[s.network] || {
          fr: s.network,
          en: s.network,
          color: "#A19E9C",
        };
        return (
          <li
            key={s.network}
            data-testid={`share-network-${s.network}`}
            className="flex items-center justify-between text-xs"
          >
            <span className="flex items-center gap-2 text-[#F2EBE5]">
              <span
                className="w-2 h-2 rounded-full inline-block"
                style={{ backgroundColor: meta.color }}
              />
              {lang === "fr" ? meta.fr : meta.en}
            </span>
            <span className="text-[#C5A059] font-medium">{s.count}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default ShareNetworksList;
